import { useQuery } from "@tanstack/react-query";
import { getNotificationsAdminAll } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const NOTIFICATIONS_QUERY_KEY = "ALL_ADMIN_NOTIFICATIONS";

export const allAdminNotificationsKeys = {
  all: [NOTIFICATIONS_QUERY_KEY] as const,
};

export const useAllNotifications = () =>
  useQuery({
    queryKey: allAdminNotificationsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getNotificationsAdminAll(),
    ),
    refetchOnWindowFocus: false,
    refetchInterval: MS_TIME.halfMinute,
  });
